document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('header nav .has-dropdown > a, header nav [aria-haspopup] > a');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const parent = trigger.parentElement;
      const isOpen = parent.classList.contains('is-open');
      document.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
      if (!isOpen) parent.classList.add('is-open');
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('header nav')) {
      document.querySelectorAll('.is-open').forEach(el => el.classList.remove('is-open'));
    }
  });
});
